import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import T from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Button, FormControl, MenuItem, Select, InputLabel } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyledContent, StyledContentGridColumn, StyledHandlers, StyledNewDialog } from '../elements';
import { PlcProtocols } from 'attrs/plcConfigValues';
import { updateMachineAutomationSystem } from 'redux/machines/actions';

const EditAutomationSystemModal = ({ open, handleClose, machineId, automationSystem }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [newPlcType, setNewPlcType] = useState(null);

  useEffect(() => {
    setNewPlcType(automationSystem.plc_type);
  }, [open, automationSystem]);

  const handleUpdateAutomationSystem = plcType => {
    const payload = {
      plc_type: plcType
    };
    dispatch(updateMachineAutomationSystem(machineId, payload));
    handleClose();
  };

  const actionBar = (
    <StyledHandlers>
      <Button color="secondary" onClick={handleClose}>
        {t('form.cancel')}
      </Button>
      <Button
        disabled={!newPlcType}
        variant="contained"
        style={{ padding: '1rem 2.5rem' }}
        onClick={() => newPlcType && handleUpdateAutomationSystem(newPlcType)}
      >
        {t('form.save')}
      </Button>
    </StyledHandlers>
  );

  const handlePlcChange = event => {
    const plc = event.target.value;
    setNewPlcType(plc);
  };

  return (
    <StyledNewDialog
      open={open}
      handleClose={handleClose}
      title={t('machines.detail.automation_system.edit_automation_system')}
      subTitle={t('machines.detail.automation_system.select_an_automation_system_model')}
      maxWidth="1062px"
      displayActionBar="true"
      actionBar={actionBar}
      content={
        <StyledContent>
          <FormControl sx={{ width: '100%' }}>
            <StyledContentGridColumn>
              <FormControl variant="filled" required fullWidth>
                <InputLabel id="automation-system-label">{t(`machines.detail.automation_system.model`)}</InputLabel>
                <Select
                  fullWidth
                  IconComponent={KeyboardArrowDownIcon}
                  labelId="plc-label"
                  id="plc-select"
                  value={newPlcType}
                  onChange={handlePlcChange}
                >
                  {PlcProtocols.map(item => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.type}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </StyledContentGridColumn>
          </FormControl>
        </StyledContent>
      }
    />
  );
};

EditAutomationSystemModal.propTypes = {
  open: T.bool,
  handleClose: T.func,
  machineId: T.string,
  automationSystem: T.shape({
    plc_type: T.string
  }).isRequired
};

export default EditAutomationSystemModal;
